import { isNoAccessStatus } from "../../../common/errors/isNoAccessError";

export interface OrganizationRef {
  id: string;
  name: string;
}

export type EventAccess = "open" | "denied" | "failed";

export type EventAccessProbe = (eventId: string, organizationId: string) => Promise<EventAccess>;

export const probeBuyerEventAccess: EventAccessProbe = async (eventId, organizationId) => {
  try {
    const response = await fetch(`${import.meta.env.VITE_BFF_BASE_URL}/api/buyer/events/${eventId}`, {
      credentials: "include",
      headers: { organizationId },
    });
    if (response.ok) return "open";
    return isNoAccessStatus(response.status) ? "denied" : "failed";
  } catch {
    return "failed";
  }
};

export interface OpenableOrganizations {
  openable: OrganizationRef[];
  anyProbeFailed: boolean;
}

export const organizationsThatCanOpen = async (
  eventId: string,
  candidates: OrganizationRef[],
  probe: EventAccessProbe,
): Promise<OpenableOrganizations> => {
  const verdicts = await Promise.all(
    candidates.map((org) => probe(eventId, org.id).catch((): EventAccess => "failed")),
  );
  return {
    openable: candidates.filter((_, index) => verdicts[index] === "open"),
    anyProbeFailed: verdicts.includes("failed"),
  };
};
